'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = combineActions;
var ACTION_TYPE_DELIMITER = exports.ACTION_TYPE_DELIMITER = '||';

function combineActions() {
  for (var _len = arguments.length, actionTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionTypes[_key] = arguments[_key];
  }

  return actionTypes.join(ACTION_TYPE_DELIMITER);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/flux-actions/static-1.35/js/combineActions.js
// module id = 189
// module chunks = 0